import { Drawer } from '@/contasis';
import { useFlujoEfectivoRetroalimentacion } from '../hooks/useFlujoEfectivoRetroalimentacion';
import { useRetroalimentacion } from '../hooks/useRetroalimentacion';
import { CuerpoRetroalimentacion, SelectorFlujoRetroalimentacion } from './ContenidoRetroalimentacion';

export function PanelRetroalimentacion() {
  const { panelAbierto, cerrarPanel } = useRetroalimentacion();
  const { flujo } = useFlujoEfectivoRetroalimentacion();

  return (
    <Drawer
      isOpen={panelAbierto}
      onClose={cerrarPanel}
      title="Retroalimentación"
      size={flujo === 'resultados' ? 'xl' : 'md'}
      tabBar={
        <div className="py-3">
          <SelectorFlujoRetroalimentacion />
        </div>
      }
    >
      <CuerpoRetroalimentacion />
    </Drawer>
  );
}
